import type { GrnStatus } from '@api/warehouse-ops';
import type { FC } from 'react';

import { StatusBadge, type StatusStyle } from '../../procurementOrders/shared';

/**
 * Same chip and muted palette as the Stock Transfers grid: blue while it waits on QC, purple
 * while it waits on putaway, the Purchase Orders green once done, muted red when reversed.
 */
const STATUS_TONE: Record<GrnStatus, Omit<StatusStyle, 'label'>> = {
    RECEIVED: { color: 'rgb(1, 149, 255)', bg: 'rgba(1, 149, 255, 0.12)' },
    QC_DONE: { color: 'rgb(124, 95, 240)', bg: 'rgba(144, 117, 255, 0.16)' },
    PUTAWAY_DONE: { color: 'rgb(45, 187, 136)', bg: 'rgba(45, 187, 136, 0.14)' },
};
const REVERSED_TONE = { color: 'rgb(205, 101, 101)', bg: 'rgba(205, 101, 101, 0.12)' };

const STATUS_LABEL: Record<GrnStatus, string> = {
    RECEIVED: 'QC Pending',
    QC_DONE: 'Putaway Pending',
    PUTAWAY_DONE: 'Complete',
};

type Props = {
    status: GrnStatus;
    reversed?: boolean;
    itemType?: string;
    label?: string;
};

const GrnStatusBadge: FC<Props> = ({ status, reversed, itemType, label }) => {
    if (reversed) return <StatusBadge status={status} styleOverride={{ ...REVERSED_TONE, label: 'Reversed' }} />;
    // Material is judged at the gate when it is received; there is no later step to show.
    if (itemType === 'material') {
        return <StatusBadge status={status} styleOverride={{ ...STATUS_TONE.PUTAWAY_DONE, label: 'Received' }} />;
    }
    return <StatusBadge status={status} styleOverride={{ ...STATUS_TONE[status], label: label ?? STATUS_LABEL[status] }} />;
};

export default GrnStatusBadge;
